// extracted by mini-css-extract-plugin
export default {"core-deposit-label--large":"core-deposit-label--large__Z9ve_We","core-deposit-label--small":"core-deposit-label--small_nfuID3OF"};